<lucide-icon [name]="name()" [size]="resolvedSize()" />
